export enum ReservationEventTypes {
    Created = "Created",
    SMSSent = "SMS Sent",
    IntakeSent = "Intake Sent",
    Confirmed = "Confirmed",
    Cancelled = "Cancelled",
    UnCancelled = "Un-Cancelled",
    Rescheduled = "Rescheduled",
    ClinicCancelled = "Clinic Cancelled",
    ClientArrived = "Client Arrived",
    UpdatedViaIntake = "Updated Via Intake",
    ClientIndicatesNotComing = "Client Indicates Not Coming",
	LinkedToClient = "Linked To Client"
}
